export const arr =[
    {key:"Green Light",value:"Feu vert"},
    {key:"Pumpkin Reports",value:"Rapports sur les citrouilles"},
    {key:"LMNs",value:"LMN"},
    {key:"Telmo & Tula - Arts & Crafts",value:"Telmo & Tula - Arts et artisanat"},
    {key:"Telmo & Tula - Little Cooks",value:"Telmo & Tula - Petits cuisiniers"},
    {key:"GLUMPERS",value:"GLUMPERS"},
    {key:"Raindrop",value:"Goutte de pluie"},
    {key:"Van Dogh",value:"Van Dogh"},
    {key:"Pedestrian Traffic Light",value:"Feu de circulation pour piétons"},
    {key:"Wear Seat Belt",value:"Portez la ceinture de sécurité"},
    {key:"Getting Out Of The Car",value:"Sortir de la voiture"},
    {key:"Traffic Police",value:"Police de la circulation"},
    {key:"Getting Off A Bus",value:"Descendre d'un bus"},
    {key:"Eyes-Closed Friday",value:"Vendredi les yeux fermés"},
    {key:"Fear Itself",value:"Peur de lui-même"},
    {key:"Crazy In Love",value:"Fou d'amour"},
    {key:"Indecision",value:"Indécision"},
    {key:"Sabotage",value:"Sabotage"},
    {key:"The Electric Current",value:"Le courant électrique"},
    {key:"Lost",value:"Perdue"},
    {key:"The Wise Fluoride",value:"Le fluorure sage"},
    {key:"The Periodic Table",value:"Le tableau périodique"},
    {key:"Stuffed Toys",value:"Jouets en peluche"},
    {key:"Multicoloured Bottles",value:"Bouteilles multicolores"},
    {key:"Paper Animals",value:" Animaux en papier"},
    {key:"Space Rocket",value:"Fusée spatiale"},
    {key:"Coloured Fish",value:"Poisson coloré"},
    {key:"Fresh Fruit Salad",value:"Salade De Fruits Frais"},
    {key:"Healthy Muesli",value:"Muesli santé"},
    {key:"Apple Toast & Kiwi Shake",value:"Toast aux pommes et milk-shake au kiwi"},
    {key:"Chocolate Cake",value:"Gâteau au chocolat"},
    {key:"Anchovie Sandwich & Strawberry Shake",value:"Sandwich aux anchois et milkshake aux fraises"},
    {key:"A Day At The Beach",value:"Une journée à la plage"},
    {key:"The Egg",value:"L'oeuf"},
    {key:"Night Of Terror",value:"Nuit de terreur"},
    {key:"Ski Day",value:"Journée de ski"},
    {key:"Skate",value:"Patin"},
    {key:"Raindrops Birth",value:"Naissance des gouttes de pluie"},
    {key:"The Cloud Castle",value:"Le château des nuages"},
    {key:"Welcome Mr.Hydrogen",value:"Bienvenue Monsieur Hydrogène"},
    {key:"Raindrop The Builder",value:"Raindrop le constructeur"},
    {key:"Frosty  The Snow Lord",value:"Frosty le Seigneur des Neiges"},
    {key:"Yellow Submarine ",value:"Sous-marin jaune"},
    {key:"Clown fishing",value:"Pêche au clown"},
    {key:"Beach Dancer",value:"Danseuse de plage"},
    {key:"Baby turtle ",value:"Bébé tortue"},
    {key:"Princess and Bear",value:"Princesse et ours"},
    

]